import type { DkModuleOptions } from '@dk/types'
import { useRuntimeConfig } from '#imports'

export function useDkConfig() {
    const config = useRuntimeConfig()

    return config.public.dk as DkModuleOptions
}
